import React from 'react';
import styles from '@dazn/lp-web/src/components/BannerSlider/MobileSlider/mobile-slider.module.css';
import {getCardVariants} from '@dazn/lp-web/src/components/BannerSlider/MobileSlider/mobile-slider.utils';
import MobileSliderCard from '@dazn/lp-web/src/components/BannerSlider/MobileSlider/MobileSliderCard';
import {motion} from 'framer-motion';
import {IMobileSliderItemProps} from '@dazn/lp-web/src/components/BannerSlider/MobileSlider/mobile-slider.types';
import {exitTransForms} from '@dazn/lp-web/src/components/BannerSlider/MobileSlider/MobileSlider';
import {useVideoBannerContext} from '../../VideoBanner/VideoBannerContext';

const MobileSliderItem: React.FC<IMobileSliderItemProps> = (props) => {
    const {
        data,
        direction,
        id,
        isDraggable,
        onTouchStart,
        onTouchEnd,
        onSwipe,
        animate,
        touched,
        activeIndex,
        rotatingBannerIndex
    } = props;
    const existingXValue = exitTransForms.get(id)?.x || 0;
    const existingRotation = exitTransForms.get(id)?.rotate || 0;

    const {setThumbnail} = useVideoBannerContext();

    const isVideoBanner = data?.backgroundType === 'video';
    const videoPosterImage = data?.videoPosterImage;

    React.useEffect(() => {
        setThumbnail(videoPosterImage);
    }, [isVideoBanner]);

    return (
        <motion.div
            id={`card-${data?.id}`}
            className={styles.bannerCard}
            variants={getCardVariants({direction, touched})}
            initial="remainings"
            animate={animate}
            exit="exit"
            style={{x: existingXValue, rotate: existingRotation}}
        >
            <MobileSliderCard
                data={data}
                isDraggable={isDraggable}
                onTouchStart={onTouchStart}
                onTouchEnd={onTouchEnd}
                onSwipe={onSwipe}
                activeIndex={activeIndex}
                rotatingBannerIndex={rotatingBannerIndex}
            />
        </motion.div>
    );
};

export default MobileSliderItem;
